export default {
    ACTIVE: 'RESERVED',
    CANCELLED: 'DELETED',
    FAILED: 'FAILED'
};
